//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { TagsContext } from "../context/TagsContext";



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function ContainerSearch() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { tagSearched, setTagSearched } = useContext(TagsContext); // Estado que armazena o texto da Busca



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* INPUT DE PESQUISA DE TAG */}
            <input
                type="text"
                placeholder="Buscar tags"
                value={tagSearched}
                onChange={(e) => setTagSearched(e.target.value)}
                className="bg-surface-2 text-white p-2 rounded border border-white/[0.08]"
            />

        </>
    )
}